<template>
  <div>
    <web-header :searchStatus="$route.query.moduleId"></web-header>
    <mini-crumb height="60px" location="反哺计划"></mini-crumb>
    <div class="details-box" ref="viewBox">
      <div class="details-top">
        <div id="project-top">
          <div class="top-box">
            <div class="top-left">
              <img :src="data.cover_photo_text[0].path" alt />
            </div>
            <div class="top-right">
              <h3>{{data.title}}</h3>
              <span></span>
              <p>{{data.description}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="detail_main_outside">
        <div class="detail_main_outside_top">
          <div class="wrap">
            <div class="wrap_box">
              <div class="detail current">
                <a href="javascript:void(0)">反哺计划介绍</a>
              </div>
            </div>
          </div>
        </div>
        <el-row>
          <el-col :span="18">
            <div class="detail_time_attr_det_con">
              
              <div id="dt_content" class="dt_content" style="padding:20px 20px 20px 0" v-html="data.content"></div>

             
            </div>
          </el-col>
          <el-col :span="6">
            <recommend-news :tags="data.tag_list" v-if="data.tag_list"></recommend-news>
            <recommend-activity :tags="data.tag_list" v-if="data.tag_list"></recommend-activity>
            <!-- <recommend-project></recommend-project> -->
          </el-col>
        </el-row>
      </div>
    </div>
    <WtFooter></WtFooter>
    <!--WtLoginDialog :dialogTableVisible="dialogTableVisible"></WtLoginDialog-->
  </div>
</template>
<script>
import webHeader from "../Public/header";
import miniCrumb from "../Public/miniCrumb";
import recommendNews from "_c/recommend/news";
import recommendActivity from "_c/recommend/activity";
import recommendProject from "_c/recommend/project";
export default {
  components: {
    webHeader,
    miniCrumb,
    recommendNews,
    recommendActivity,
    recommendProject
  },
  data() {
    return {
      signText: "我要报名",
      disabled: false,
      dialogTableVisible: true,
      hover: false,
      data: {
        cover_photo_text:[
          {
            path:""
          }
        ]
      },
      applyData: {},
      search: {
        type: null
      },
      liData: ["liBg1", "liBg2", "liBg3"],
      applyInfo: {
        list: [],
        total: 0
      }
    };
  },
  methods: {
    test() {
      this.$router.push({ name: "userInfo" });
    },
    //活动报名
    sign(e) {
      //如果是志愿者或者是反哺大学生  允许直接报名
      if (e.is_college_student || e.is_volunteer) {
        this.applyData.user_id = e.id;
        this.disabled = true;
        this.signText = "正在提交报名";
        this.$db
          .post(this.$url.activity.apply.url, this.applyData)
          .then(resp => {
            if (resp && resp.data) {
              this.$message({
                message: "报名成功",
                type: "success",
                duration: 1000,
                onClose: function() {
                  window.location.reload();
                }
              });
            } else {
              this.disabled = false;
              this.signText = "我要报名";
            }
          });
      } else {
        //登录过，但不是志愿者或者反哺大学生
        this.$confirm("您还不是志愿者，请先注册成为志愿者", "消息提示", {
          confirmButtonText: "立即前往注册",
          showCancelButton: false,
          type: "warning"
        })
          .then(() => {
            //跳转到志愿者注册页面
          })
          .catch(() => {});
      }
    },
    scrollBehavior() {
      document.getElementById("dt_list_main").scrollIntoView();
    },
    getDate(date, format = "M") {
      switch (format) {
        case "M": {
          return date.substring(5, 7);
          break;
        }
        case "D": {
          return date.substring(8, 10);
          break;
        }
      }
    },
    getClass(index) {
      let j = parseInt(index / 3);
      if (j % 2 == 0) {
        // 再通过取模来设置每隔3行显示不同的两种颜色
        return "liBg2";
      } else {
        //return "liBg3"
        return "liBg2";
      }
    },
    handleScroll() {
      if (this.getScrollBottomHeight() <= -650) {
        this.hover = true;
      } else {
        this.hover = false;
      }
    },
    //滚动条到底部的距离
    getScrollBottomHeight() {
      return (
        this.getPageHeight() - this.getScrollTop() - this.getWindowHeight()
      );
    },
    //页面高度
    getPageHeight() {
      return document.querySelector("html").scrollHeight;
    },
    //滚动条顶 高度
    getScrollTop() {
      var scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop =
        bodyScrollTop - documentScrollTop > 0
          ? bodyScrollTop
          : documentScrollTop;
      return scrollTop;
    },
    getWindowHeight() {
      var windowHeight = 0;
      if (document.compatMode == "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight;
    },
    getData(id) {
      let that = this;
      this.$db.get(this.$url.news.url + "/" + id).then(resp => {
        this.data = resp.data;
        console.log(resp,"resp")
      });
    }
  },
  mounted() {
    let id = this.$route.query.id;
    this.activity_id = id;
    this.getData(id);
    
  },
  
};
</script>

<style lang="scss" scoped>
#project-top {
  width: 100%;
}
.details-box {
  max-width: 1300px;
  margin: 0 auto;
  .details-content {
    display: flex;
    justify-content: space-between;
    margin: 40px 0;
    .content-left {
      width: 900px;
    }
    .content-right {
      width: 360px;
    }
  }
}
.top-box {
  max-width: 1300px;
  display: flex;
  .top-left {
    width: 50%;
    height: 280px;
    > img {
      width: 100%;
      height: 100%;
    }
  }
  .top-right {
    //width: 280px;
    //height: 500px;
    background-color: #e83a16;
    padding: 0 40px;
    width:100%;
    > h3 {
      font-size: 22px;
      color: #ffffff;
      margin-top: 20px;
      overflow: hidden; /*超出部分隐藏*/
      white-space: nowrap; /*不换行*/
      text-overflow: ellipsis; /*超出部分省略号显示*/
    }
    > span {
      display: block;
      width: 25px;
      height: 3px;
      background-color: #ffffff;
      margin-top: 16px;
    }
    > p {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: #fff;
      margin-top: 35px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/News/fanbu.vue